import axios from "../http";

let module = "/sysPermission";

function selectMenuList(data) {
    return axios.post(module + '/selectMenuList', data);
}

function addMenu(data) {
    return axios.post(module + '/addMenu', data);
}

function updateMenu(data) {
    return axios.post(module + '/updateMenu', data);
}

function deletePermission(data) {
    return axios.post(module + '/deletePermission', data);
}

function updateMenuOrder(data) {
    return axios.post(module + '/updateMenuOrder', data);
}

function addOperation(data) {
    return axios.post(module + '/addOperation', data);
}

function selectOperation(data) {
    return axios.post(module + '/selectOperation', data);
}

function updateOperation(data) {
    return axios.post(module + '/updateOperation', data);
}

function treePermission(data){
    return axios.get(module + '/treePermission',{params:data});
}

export default {
    selectMenuList,
    addMenu,
    updateMenu,
    deletePermission,
    updateMenuOrder,
    addOperation,
    selectOperation,
    updateOperation,
    treePermission
}
